import { useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { SEARCH_RESULTS_GET } from '@annunciate/query/dist/queries/search';
import { request } from '../request';
export const useSearchQuery = (query) => {
    const variables = {
        query,
        page: 0,
        perPage: 20,
    };
    const { fetchNextPage, fetchPreviousPage, hasNextPage, hasPreviousPage, isFetchingNextPage, isFetchingPreviousPage, isPending, data, error, isError, } = useInfiniteQuery({
        queryKey: [`searchResults`, variables],
        queryFn: async ({ pageParam = 0 }) => {
            if (!variables.query) {
                return null;
            }
            variables.page = pageParam;
            return request({
                query: SEARCH_RESULTS_GET,
                variables,
            });
        },
        initialPageParam: 0,
        getPreviousPageParam: firstPage => firstPage?.Search.prevPage,
        getNextPageParam: lastPage => lastPage?.Search.nextPage,
    });
    const formatData = useCallback((data) => {
        let results;
        if (data?.pages) {
            results = data?.pages?.reduce((acc, page) => {
                if (page) {
                    return [
                        ...acc,
                        ...page.Search.results,
                    ];
                }
                return acc;
            }, []);
        }
        else {
            results = [];
        }
        return {
            count: data?.pages[0]?.Search.count,
            results,
        };
    }, []);
    return {
        fetchNextPage,
        fetchPreviousPage,
        hasNextPage,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isPending,
        data: formatData(data),
        error,
        isError,
    };
};
//# sourceMappingURL=useSearchQuery.js.map